export enum Destinations {
  your_ip= 'you_ip',
  ip_address = 'ip_address',
  gcx_sites = 'gcx_sites'
}
